<template>
  <div id="app">
    <SMSModal ref="SMSModal"></SMSModal>
    <PaymentModal v-if="auth === true && status === true" ref="PaymentModal"></PaymentModal>
    <PayoutModal v-if="auth === true && status === true" ref="PayoutModal"></PayoutModal>
    <PaymentHistoryModal v-if="auth === true && status === true" ref="PaymentHistoryModal"></PaymentHistoryModal>
    <PasswordModal v-if="auth === true && status === true" ref="PasswordModal"></PasswordModal>
    <PartnersHistoryModal v-if="auth === true && status === true" ref="PartnersHistoryModal"></PartnersHistoryModal>
    <RegistrationModal v-if="status === true" ref="RegistrationModal"></RegistrationModal>
    <ActivationModal v-if="status === true" ref="ActivationModal"></ActivationModal>

    <div class="preloader" id="preloader" v-show="!status">
      <div class="loading"><div class="loading-bar"></div><div class="loading-bar"></div><div class="loading-bar"></div><div class="loading-bar"></div></div>
    </div>

    <header id="header" class="navbar">
      <div class="topbar" v-html="topbar" v-if="topbar"></div>

      <a class="navbar-brand" style="" href="/">
          <icon scale="10" name="logo" style="vertical-align: middle"></icon>
      </a>

      <ul class="nav navbar-nav pull-right">
        <li style="margin-right: 5px; width: 130px;" v-if="false">
          <a @click.prevent="change" href="#" style="font-weight: bold">
            <svg v-if="lang==='ru'" width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="1.75" fill="white" stroke="#F5F5F5" stroke-width="0.5"/>
              <mask id="mask0_142_173" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="20">
                <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="1.75" fill="white" stroke="white" stroke-width="0.5"/>
              </mask>
              <g mask="url(#mask0_142_173)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 13.3334H28V6.66669H0V13.3334Z" fill="#0C47B7"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 20H28V13.3333H0V20Z" fill="#E53B35"/>
              </g>
            </svg>
            <svg v-else width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="28" height="20" rx="2" fill="white"/>
              <mask id="mask0_142_122" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="20">
                <rect width="28" height="20" rx="2" fill="white"/>
              </mask>
              <g mask="url(#mask0_142_122)">
                <rect width="28" height="20" fill="#0A17A7"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M-1.28247 -1.91644L10.6667 6.14335V-1.33333H17.3333V6.14335L29.2825 -1.91644L30.7737 0.294324L21.3263 6.66667H28V13.3333H21.3263L30.7737 19.7057L29.2825 21.9165L17.3333 13.8567V21.3333H10.6667V13.8567L-1.28247 21.9165L-2.77365 19.7057L6.67374 13.3333H-9.53674e-07V6.66667H6.67374L-2.77365 0.294324L-1.28247 -1.91644Z" fill="white"/>
                <path d="M18.668 6.33219L31.3333 -2" stroke="#DB1F35" stroke-width="0.666667" stroke-linecap="round"/>
                <path d="M20.0128 13.6975L31.3666 21.3503" stroke="#DB1F35" stroke-width="0.666667" stroke-linecap="round"/>
                <path d="M8.00552 6.31046L-3.83749 -1.67099" stroke="#DB1F35" stroke-width="0.666667" stroke-linecap="round"/>
                <path d="M9.29003 13.6049L-3.83749 22.3105" stroke="#DB1F35" stroke-width="0.666667" stroke-linecap="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12H12V20H16V12H28V8H16V0H12V8H0V12Z" fill="#E6273E"/>
              </g>
            </svg>
            {{ $t('messages.lang') }}
          </a>
        </li>
      </ul>

      <user v-if="user.email"></user>

    </header>

    <section id="content">
      <section class="main padder" style="padding: 15px;">
        <div class="row">
          <transition name="list">
            <div v-if="status === true" class="col-lg-6 col-md-6" :class="{ 'col-md-pull-6 col-lg-pull-6': auth === false }" id="order">

              <Gift v-if="auth === false && status === true" ref="gift"></Gift>

              <section class="panel">
                <div class="panel-body" style="padding-bottom: 5px; padding-top: 0px;">
                  <Order ref="order"></Order>
                </div>
              </section>
            </div>
          </transition>

          <div class="col-lg-6 col-md-6" v-if="auth === false && status === true" >
            <section class="panel">
              <div class="panel-body">
                <Login ref="login"></Login>
              </div>
            </section>
          </div>

          <transition name="list">
            <div class="col-lg-6 col-md-6" v-if="auth === true && status === true" id="second">
              <section class="panel">
                <div class="tabs">
                  <ul class="btn-group-justified" style="padding: 0">
                    <li @click="tab=1" role="presentation" class="btn" style="border-top-left-radius: 12px;" :class="{ active: tab === 1}" ><icon name="list" scale="0.8"></icon> {{ $t("messages.tasks.title") }}</li>
                    <li @click="tab=2" role="presentation" class="btn" :class="{ active: tab === 2}"><icon name="dollar-sign" scale="0.8"></icon> {{ $t("messages.partners.title") }}</li>
                    <li v-if="false" @click="tab=3" role="presentation" class="btn" style="border-top-right-radius: 12px;" :class="{ active: tab === 3}"><icon name="user-headset" scale="0.8"></icon> {{ $t("messages.help") }}{{ user.messages ? ' (' + user.messages + ')' : ''}}</li>
                  </ul>
                </div>

                <div class="panel-body">
                  <!-- Nav tabs -->
                  <div class="tab-content">
                    <div role="tabpanel" class="tab-pane active">
                      <Tasks v-show="tab === 1" ref="tasks"></Tasks>
                      <Partners v-show="tab === 2" ref="partners"></Partners>
                      <Help v-if="tab === 3" ref="help"></Help>
                    </div>
                  </div>
                </div>
              </section>

            </div>
          </transition>
        </div>
      </section>
    </section>

    <transition name="list">
      <footer id="footer" v-if="status === true">
        <div class="text-center padder clearfix" v-html="footer" @click="handleFooter">
        </div>
      </footer>
    </transition>
  </div>
</template>

<script>
import User from './components/User.vue'
import Login from './components/Login.vue'
import Partners from './components/Partners.vue'
import Gift from './components/Gift.vue';
import Help from "./components/Help";

import PayoutModal from './components/PayoutModal.vue'
import PaymentModal from './components/PaymentModal.vue'
import PaymentHistoryModal from './components/PaymentHistoryModal.vue'
import PartnersHistoryModal from './components/PartnersHistoryModal.vue'
import RegistrationModal from './components/RegistrationModal.vue'
import ActivationModal from './components/ActivationModal.vue'
import PasswordModal from './components/PasswordModal.vue'
import SMSModal from './components/SMSModal.vue'
let CrossStorageClient = require('cross-storage').CrossStorageClient;
// eslint-disable-next-line no-undef
require('./assets/styles.css');
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-slider-component/dist-css/vue-slider-component.css'
import 'vue-slider-component/theme/default.css'

const is_app = 0;

export default {
    name: 'app',
    components: {
        User,
        'Order': () => import('./components/Order.vue'),
        Login,
        PaymentModal,
        PaymentHistoryModal,
        'Tasks': () => import('./components/Tasks.vue'),
        Partners,
        PayoutModal,
        Gift,
        PartnersHistoryModal,
        PasswordModal,
        RegistrationModal,
        ActivationModal,
        SMSModal,
        Help,
    },
    data: function() { return {
        auth: null,
        tab: 1,
        web: 1,
        key: '',
        user: {},
        webs: [],
        services: [],
        payments: [],
        cache: false,
        status: false,
        lang: '',
        logo: '',
        site: '',
        email: '',
        topbar: '',
        contacts: false,
        widget: {},
        is_app: is_app,
        footer: '',
    }},
    created: function(){
        this.logo = window.settings.logo;
        this.site = window.settings.site;
        this.email = window.settings.email;
        this.footer = window.settings.footer;

        window.onLoadCallback = window.jivo_onResizeCallback = () => {
          if(this.auth) {
            setTimeout(() => {
              const link = document.querySelector('[class*=link]');
              if(link) {
                link.href += (link.href.includes('tg://') ? '&' : '?') + 'start=' + this.user.user_id;
              }
            },500);
          }
        };

        const interval = setInterval(() => {
          const box = document.querySelector('jdiv[class^=box]');

          if(box && this.auth) {
            const inputFields = box.querySelectorAll('input[name]');

            setTimeout(() => {
              if(!this.is_app) {
                document.querySelector('[class*=overlay]')?.dispatchEvent(new CustomEvent('click'))
              }

              let params = {
                name: `id:${this.user.user_id}`,
                email: this.user.email
              };

              inputFields.forEach((input) => {
                const fieldName = input.getAttribute('name');
                if (params.hasOwnProperty(fieldName)) {
                  setTimeout(() => {
                    input.value = params[fieldName];
                    input.dispatchEvent(new CustomEvent('input'))
                    input.dispatchEvent(new CustomEvent('change'))
                  }, 300)
                }
              });

              if(this.is_app) {
                document.querySelector('[class*=overlay]')?.dispatchEvent(new CustomEvent('touchstart'))
                setTimeout(() => box.querySelector('[class*=button_]').dispatchEvent(new CustomEvent('touchstart')), 500);
              }
              else {
                setTimeout(() => box.querySelector('[class*=button_]').dispatchEvent(new CustomEvent('click')), 500);
              }
            }, 1000);

            clearInterval(interval);
          }
        }, 100);

        if(this.site === 'likemania.kz') {
          this.$i18n.mergeLocaleMessage('ru', {
            messages: {
            currency: '₸'
            }
          })
        }

      this.init();
    },
    methods: {
        help() {
            document.querySelector("body > pf-widget")?.shadowRoot.querySelector("#PWPreviewWidgetButton").click()
        },
        redirect(lang) {
          if(window?.notRedirect) return;

          let param = location.hash.replace('#', '').replace('lang', '');

          if(this.site === 'likemania.com' && lang === 'ru') {
            let storage = new CrossStorageClient('https://likemania.ru/test2', { timeout: 5000 })

            storage.onConnect().then(async () => {
              await storage.set('key', this.key)
              window.location = 'https://likemania.ru/#lang|' + param
            }).catch(() => {
              window.location = 'https://likemania.ru/#lang|' + param
            })
          }

          if(['likemania.ru', 'likemania.kz'].includes(this.site) && lang === 'en') {
            let storage = new CrossStorageClient('https://likemania.com/test2', { timeout: 5000 })

            storage.onConnect().then(async () => {
              await storage.set('key', this.key)
              window.location = 'https://likemania.com/#lang|' + param
            }).catch(() => {
              window.location = 'https://likemania.com/#lang|' + param
            })
          }
        },
        init: function (is_register, is_gift) {
          is_register = is_register || false;
          is_gift = is_gift || false;

          if(window.localStorage.getItem('key') === 'null') {
            window.localStorage.setItem('key', '');
          }

          this.key = window.localStorage.getItem('key');

          if(!this.lang) {
            this.lang = window.localStorage.getItem('lang') ? window.localStorage.getItem('lang') : (navigator.language.includes('ru') ? 'ru' : 'en');
            this.$i18n.locale = this.lang;
          }

          if(location.hash.includes('#lang')) {
            window.localStorage.setItem('lang', this.lang);
          }

          if(this.site !== 'likemania.kz') {
            this.redirect(window.localStorage.getItem('lang') ?? (navigator.language.includes('ru') ? 'ru' : 'en'))
          }

          var self = this;

          this.topbar = this.lang === 'ru' ? window.settings.topbar_ru : window.settings.topbar_en;

          this.$http.jsonp('balance', {
            params: {
              key: this.key,
              lang: this.lang,
            }
          }).then(function(userinfo){
            if(window.localStorage.getItem('webs') && window.localStorage.getItem('services') && window.localStorage.getItem('payments') && self.cache)
            {
              self.status = true;

              self.services = JSON.parse(window.localStorage.getItem('services'));
              self.webs = JSON.parse(window.localStorage.getItem('webs'));
              self.payments = JSON.parse(window.localStorage.getItem('payments'));
            }
            else
            {
              Promise.all([
                self.$http.jsonp('webs', {
                  params: {
                    key: this.key,
                    lang: this.lang,
                    extended: 1,
                  }
                }),
                self.$http.jsonp('services', {
                  params: {
                    key: this.key,
                    lang: this.lang,
                    extended: 1,
                  }
                }),
                self.$http.jsonp('payments', {
                  params: {
                    key: this.key,
                    lang: this.lang,
                  }
                }),
              ]).then(function(responses){
                window.localStorage.setItem('webs', JSON.stringify(responses[0].body));
                window.localStorage.setItem('services', JSON.stringify(responses[1].body));
                window.localStorage.setItem('payments', JSON.stringify(responses[2].body));

                self.webs = responses[0].body;
                self.services = responses[1].body;
                self.payments = responses[2].body;

                if(self.site === 'likemania.kz' && Array.isArray(self.payments)) {
                  self.payments.unshift(self.payments.splice(self.payments.findIndex(item => item.id === 58), 1)[0])
                }

                if(typeof self.webs.status !== "undefined")
                {
                  window.localStorage.removeItem('key');
                  window.settings.token = '';
                  this.init();
                }
                else
                {
                  self.user = userinfo.body;
                  self.auth = typeof userinfo.body.user_id !== "undefined";
                  self.hide = typeof userinfo.body.hide2 !== "undefined" ? userinfo.body.hide2 : false;
                  self.tab = 1;
                  self.status = true;

                  window.jivo_onResizeCallback();

                  if(self.user.sms && (!window.localStorage.getItem('sms_showed') ?? false)) {
                    self.$refs.SMSModal.status = true
                  }

                  setTimeout(() => self.$initializeReCaptcha(), 1000 * 0);

                  if (is_register) {
                    self.$refs.order.submit();
                  }

                  if (is_gift) {
                    self.$swal({
                      title: self.$t('messages.gift.success_title'),
                      text: self.$t('messages.gift.success_text'),
                      icon: 'success',
                    });
                  }
                }
              }, function () {

              });
            }
          }, function () {

          });
        },
        updateBalance: function(submit)
        {
            submit = submit || false;

            this.$http.jsonp('balance', {
                params: {
                    key: this.key,
                    lang: this.lang,
                }
            }).then(function(response){
                this.user = response.body;

                if(submit && this.user.balance >= this.$refs.order.cost)
                {
                    this.$refs.order.submit();
                }

                if(this.user.sms && (!window.localStorage.getItem('sms_showed') ?? false)) {
                  this.$refs.SMSModal.status = true
                }
            }, function () {

            });
        },
        handleFooter(event) {
          if (event.target.id !== 'lang') return;
          this.change();
          event.preventDefault();
        },
        change: function () {
            this.lang = (this.lang === 'ru' ? 'en' : 'ru');
            this.$i18n.locale = this.lang;
            window.localStorage.setItem('lang', this.lang);
            this.redirect(this.lang)
            this.status = false;
            this.init();
        }
    },
    computed: {
      balance() {
        return this.site === 'likemania.kz' ? (window.settings.c * this.user.balance).toFixed(2) : this.user.balance;
      }
    }
}
</script>

<style>
  .vue-popover hr, .vue-popover h4 {
    margin: 0;
  }
  .vue-popover h4 {
    margin-top: 5px;
  }
  .vue-popover hr {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .panel .nav-tabs .help-tab {
    margin-bottom: 0;
  }
  .nav-tabs .help-tab a {
    background: rgb(49, 121, 194);
    color: #fff;
  }

  .panel {
    background: #fff;
    padding: 10px;
    border-radius: 12px;
  }

  .block .inner {
    border: 1px solid #D9E2FA;
  }

  .col-lg-6, .col-md-6 {
    float: left;
  }

  @media (min-width: 992px)
  {
    .col-md-6 {
      width: 50%;
    }
  }

  .tabs {
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -10px
  }

  .tabs .btn {
    padding: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 62px;
    text-align: center;
    color: #485291;
    background: #EFF5FF;
    box-shadow: none;
    border-radius: 0;
  }

  .tabs .btn.active {
    background: #FFFFFF;
  }

  .block .input-group {
    border: 1px solid #D9E2FA;
    border-radius: 12px;
  }


  .vac-card-window {
    box-shadow: none;
  }

  .vac-box-footer {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  body .current, [name="promo"], .list-group-item .btn {
    border: 1px solid #D9E2FA !important;
  }

  body .payment-type {
    width: 50%;
    border: 1px solid transparent;
  }

  .list-group-item .btn {

  }

  html body jdiv[class^=box], html body jdiv[class*=__mobile_][title], html body jdiv[class*=main][title] {
    display: none !important;
  }
</style>